@if (isOpen && !isMinimized) {
  <div class="import-backdrop" (click)="minimize()"></div>
}

@if (isOpen && !isMinimized) {
  <div class="import-modal">
    <div class="import-modal__header">
      <span class="import-modal__title">
        <i class="fas fa-cloud-download-alt me-2"></i>
        {{ 'ChargesWithdrawals.Import.ModalTitle' | translate }}
      </span>
      <div class="import-modal__controls">
        @if (!isLoading) {
          <button
            class="ctrl-btn"
            [title]="'ChargesWithdrawals.Import.Minimize' | translate"
            (click)="minimize()"
          >
            <i class="fas fa-minus"></i>
          </button>
        }
        @if (isDone || hasError) {
          <button
            class="ctrl-btn ctrl-btn--danger"
            [title]="'ChargesWithdrawals.Import.Close' | translate"
            (click)="close()"
          >
            <i class="fas fa-times"></i>
          </button>
        }
      </div>
    </div>

    <div class="import-modal__body">
      @if (isSetup) {
        <div class="date-range">
          <div class="date-range__field">
            <label class="date-range__label">
              <i class="fas fa-calendar-alt me-1"></i>
              {{ 'ChargesWithdrawals.Import.FromDate' | translate }}
            </label>
            <input
              type="date"
              class="date-range__input"
              [value]="fromDate"
              [max]="toDate"
              (change)="onFromDateChange($event)"
            />
          </div>
          <div class="date-range__field">
            <label class="date-range__label">
              <i class="fas fa-calendar-alt me-1"></i>
              {{ 'ChargesWithdrawals.Import.ToDate' | translate }}
            </label>
            <input
              type="date"
              class="date-range__input"
              [value]="toDate"
              [min]="fromDate"
              (change)="onToDateChange($event)"
            />
          </div>
          <button
            class="date-range__start-btn"
            (click)="startImport()"
            [disabled]="!fromDate || !toDate"
          >
            <i class="fas fa-play me-2"></i>
            {{ 'ChargesWithdrawals.Import.StartBtn' | translate }}
          </button>
        </div>
      }

      @if (isLoading) {
        <div class="import-loader">
          <i class="fas fa-clover import-loader__icon fa-spin"></i>
          <p class="import-loader__text">
            {{
              'ChargesWithdrawals.Import.Processing'
                | translate: { page: currentPage, total: totalPages }
            }}
          </p>

          <div class="progress-bar">
            <div
              class="progress-bar__fill"
              [style.width.%]="progressPercentage"
            ></div>
          </div>
          <p class="progress-bar__label">{{ progressPercentage }}%</p>

          @if (totalInserted + totalSkipped > 0) {
            <div class="progress-stats">
              <div class="stat-item stat-item--inserted">
                <i class="fas fa-check-circle"></i>
                <span>{{ totalInserted }}</span>
              </div>
              <div class="stat-item stat-item--skipped">
                <i class="fas fa-forward"></i>
                <span>{{ totalSkipped }}</span>
              </div>
            </div>
          }

          <div class="date-range date-range--readonly">
            <div class="date-range__field">
              <label class="date-range__label">
                <i class="fas fa-calendar-alt me-1"></i>
                {{ 'ChargesWithdrawals.Import.FromDate' | translate }}
              </label>
              <input
                type="date"
                class="date-range__input"
                [value]="fromDate"
                disabled
              />
            </div>
            <div class="date-range__field">
              <label class="date-range__label">
                <i class="fas fa-calendar-alt me-1"></i>
                {{ 'ChargesWithdrawals.Import.ToDate' | translate }}
              </label>
              <input
                type="date"
                class="date-range__input"
                [value]="toDate"
                disabled
              />
            </div>
          </div>
        </div>
      }

      @if (hasError) {
        <div class="import-error">
          <i class="fas fa-exclamation-triangle import-error__icon"></i>
          <p class="import-error__msg">{{ errorMessage }}</p>
        </div>
      }

      @if (pageEvents.length > 0) {
        <div class="events-list">
          @for (events of pageEvents; track trackByPage($index, events)) {
            <div class="event-row" [class.event-row--no-data]="events.noData">
              <div class="event-row__meta">
                <span class="event-row__label">
                  <i class="fas fa-file-alt me-1"></i>
                  {{
                    'ChargesWithdrawals.Import.PageOf'
                      | translate
                        : { page: events.page, total: events.totalPages }
                  }}
                </span>
                @if (events.dateRange) {
                  <span class="event-row__date">{{
                    formatDateRange(events)
                  }}</span>
                }
              </div>
              <div class="event-row__badges">
                @if (events.noData) {
                  <span class="pill pill--gray">
                    <i class="fas fa-minus me-1"></i
                    >{{ 'ChargesWithdrawals.Import.NoData' | translate }}
                  </span>
                } @else {
                  <span class="pill pill--green">
                    <i class="fas fa-plus me-1"></i>{{ events.inserted }}
                  </span>
                  @if (events.skipped > 0) {
                    <span class="pill pill--amber">
                      <i class="fas fa-forward me-1"></i>{{ events.skipped }}
                    </span>
                  }
                }
              </div>
            </div>
          }
        </div>
      }

      @if (isDone) {
        <div class="import-summary">
          <div class="summary-stat summary-stat--green">
            <i class="fas fa-check-circle summary-stat__icon"></i>
            <span class="summary-stat__value">{{ totalInserted }}</span>
            <span class="summary-stat__label">{{
              'ChargesWithdrawals.Import.Inserted' | translate
            }}</span>
          </div>
          <div class="summary-stat summary-stat--amber">
            <i class="fas fa-forward summary-stat__icon"></i>
            <span class="summary-stat__value">{{ totalSkipped }}</span>
            <span class="summary-stat__label">{{
              'ChargesWithdrawals.Import.Skipped' | translate
            }}</span>
          </div>
        </div>
      }
    </div>
  </div>
}

@if (isOpen && isMinimized) {
  <div
    class="import-minbar"
    (click)="restore()"
    [title]="
      isLoading
        ? ('ChargesWithdrawals.Import.ViewProgress' | translate)
        : isDone
          ? ('ChargesWithdrawals.Import.ViewSummary' | translate)
          : ('ChargesWithdrawals.Import.ViewError' | translate)
    "
  >
    @if (isLoading) {
      <i class="fas fa-clover fa-spin import-minbar__clover"></i>
    }
    @if (isDone) {
      <i class="fas fa-check-circle text-success"></i>
    }
    @if (hasError) {
      <i class="fas fa-exclamation-circle text-danger"></i>
    }

    <span class="import-minbar__text">
      @if (isLoading) {
        {{
          'ChargesWithdrawals.Import.Importing'
            | translate: { page: currentPage, total: totalPages }
        }}
      }
      @if (isDone) {
        {{
          'ChargesWithdrawals.Import.Done'
            | translate: { inserted: totalInserted, skipped: totalSkipped }
        }}
      }
      @if (hasError) {
        {{ 'ChargesWithdrawals.Import.ImportError' | translate }}
      }
    </span>

    <i class="fas fa-chevron-up import-minbar__expand"></i>
  </div>
}
